import * as URI from 'urijs';

export const getRootUrl = () : string => {
  return window.Gites.root_url
}

export const getRootPath = () : string => {
  return URI(getRootUrl()).path()
}

export const prefixUrlWithLocale = (path : string) : string => {
  const prefixed = URI(path)
  prefixed.path(`${getRootPath()}/${prefixed.path()}`)
  prefixed.normalizePath()

  return prefixed.valueOf()
}
